
import './pl_landlord.css';
import StaffMockHost from './staff-mock-host.vue';

export default {
  name: 'pl-landlord-mock',
  components: {
    StaffMockHost: StaffMockHost
  }
};
